import { useState } from "react";
import { Link } from "react-router-dom";
import AppPageShell from "./AppPageShell";
import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import { INSTRUCTION_TRACKS } from "../content/instructionsContent";

const TRACK_ICONS = {
  hr: GroupsOutlinedIcon,
  author: CreateOutlinedIcon,
};

export default function Instruction() {
  const [trackId, setTrackId] = useState(INSTRUCTION_TRACKS[0].id);
  const [stepIndex, setStepIndex] = useState(0);

  const track =
    INSTRUCTION_TRACKS.find((item) => item.id === trackId) ??
    INSTRUCTION_TRACKS[0];
  const steps = track.steps;
  const pageData = steps[stepIndex];
  const isLastStep = stepIndex >= steps.length - 1;
  const progressPercent = Math.round(((stepIndex + 1) / steps.length) * 100);
  const TrackIcon = TRACK_ICONS[track.id] ?? GroupsOutlinedIcon;

  const handleTrackChange = (nextTrackId) => {
    setTrackId(nextTrackId);
    setStepIndex(0);
  };

  return (
    <AppPageShell title="Обучение">
      <div className="app-instruction">
        <div className="app-instruction__hero">
          <div className="app-instruction__tracks" role="tablist" aria-label="Тип инструкции">
            {INSTRUCTION_TRACKS.map((item) => {
              const Icon = TRACK_ICONS[item.id] ?? GroupsOutlinedIcon;
              return (
                <button
                  key={item.id}
                  type="button"
                  role="tab"
                  aria-selected={item.id === trackId}
                  className={`app-instruction__track${
                    item.id === trackId ? " app-instruction__track--active" : ""
                  }`}
                  onClick={() => handleTrackChange(item.id)}
                >
                  <Icon fontSize="small" />
                  {item.label}
                </button>
              );
            })}
          </div>
          <p className="app-instruction__summary">{track.summary}</p>
          <div className="app-instruction__progress" aria-hidden="true">
            <div
              className="app-instruction__progress-fill"
              style={{ width: `${progressPercent}%` }}
            />
          </div>
          <span className="app-instruction__progress-label">
            Шаг {stepIndex + 1} из {steps.length}
          </span>
        </div>

        <nav className="app-instruction-stepper" aria-label="Шаги инструкции">
          {steps.map((step, index) => {
            const isActive = index === stepIndex;
            const isDone = index < stepIndex;

            return (
              <button
                key={step.step}
                type="button"
                className={`app-instruction-stepper__item${
                  isActive ? " app-instruction-stepper__item--active" : ""
                }${isDone ? " app-instruction-stepper__item--done" : ""}`}
                onClick={() => setStepIndex(index)}
                aria-current={isActive ? "step" : undefined}
              >
                <span className="app-instruction-stepper__dot">
                  {isDone ? "✓" : step.step}
                </span>
                <span className="app-instruction-stepper__label">{step.title}</span>
              </button>
            );
          })}
        </nav>

        {pageData ? (
          <article className="app-instruction-panel">
            <header className="app-instruction-panel__head">
              <span className="app-instruction-panel__badge">
                <TrackIcon fontSize="small" />
                Шаг {pageData.step}
              </span>
              <h2 className="app-instruction-panel__title">{pageData.title}</h2>
              <p className="app-instruction-panel__lead">{pageData.description}</p>
            </header>

            {pageData.bullets?.length ? (
              <ul className="app-instruction-panel__list">
                {pageData.bullets.map((bullet) => (
                  <li key={bullet} className="app-instruction-panel__list-item">
                    <CheckCircleOutlineIcon
                      className="app-instruction-panel__list-icon"
                      fontSize="small"
                    />
                    <span>{bullet}</span>
                  </li>
                ))}
              </ul>
            ) : null}

            {pageData.link ? (
              <div className="app-instruction-panel__action">
                {pageData.link.external === false ? (
                  <Link to={pageData.link.href} className="app-instruction-panel__link">
                    {pageData.link.label}
                  </Link>
                ) : (
                  <a
                    href={pageData.link.href}
                    className="app-instruction-panel__link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {pageData.link.label}
                  </a>
                )}
              </div>
            ) : null}

            <footer className="app-instruction-panel__nav">
              <Button
                variant="outlined"
                className="app-btn app-btn--secondary"
                startIcon={<ArrowBackIcon />}
                onClick={() => setStepIndex(stepIndex - 1)}
                disabled={stepIndex === 0}
              >
                Назад
              </Button>
              <Button
                variant="contained"
                className="app-btn app-btn--primary"
                endIcon={isLastStep ? null : <ArrowForwardIcon />}
                onClick={() => {
                  if (!isLastStep) {
                    setStepIndex(stepIndex + 1);
                  }
                }}
                disabled={isLastStep}
              >
                {isLastStep ? "Вы на финишной прямой" : "Дальше"}
              </Button>
            </footer>
          </article>
        ) : null}
      </div>
    </AppPageShell>
  );
}
